// extracted by mini-css-extract-plugin
export default {"root":"NoThreads_root__5qWPc"};